/*
 * Public API Surface of ngx-smart-banner
 */

export * from './lib/ngx-smart-banner.component';
export * from './lib/ngx-smart-banner.module';
export * from './lib/ngx-smart-banner.service';
export * from './lib/settings.interface';
